import { queryKeys } from "../queryKeys";
import { getCashWithdrawable } from "../rest/banking";
import useRequest, { type QueryOptions } from "./useRequest";

type UseGetCashWithdrawableProps = {
  accountID: string;
  options?: QueryOptions<number>;
};

export const useGetCashWithdrawable = ({
  accountID,
  options,
}: UseGetCashWithdrawableProps) => {
  const cashWithdrawable = useRequest(
    queryKeys.balances.cashWithdrawable(accountID),
    () => getCashWithdrawable(accountID),
    {
      ...options,
      enabled: !!accountID && (options?.enabled ?? true),
    },
  );

  return cashWithdrawable;
};
